// extracted by mini-css-extract-plugin
export default {"spell":"styles_spell__VQ1d8"};